import {Pipe, PipeTransform} from "@angular/core";
import {PASSPORT_TYPES} from "../_maps/passport-types";

@Pipe({name: "passportType"})
export class PassportTypePipe implements PipeTransform {
  transform(type: string): string {
    return type && PASSPORT_TYPES[type] || 'неизвестный тип документа'
  }
}
